import { createSelector } from "reselect";

import { TableColumnsState } from "../useTableStore/types";
import { ColumnsConfig } from "./types";

export const selectColumnsConfig = createSelector(
  (state: Pick<TableColumnsState<string>, "columnsState" | "columnsOrder">) => state.columnsState,
  (state: Pick<TableColumnsState<string>, "columnsState" | "columnsOrder">) => state.columnsOrder,
  (columnsState, columnsOrder): ColumnsConfig => {
    return {
      visibleColumns: columnsOrder.visible,
      hiddenColumns: columnsOrder.hidden,
      staticColumns: Object.keys(columnsState).filter(
        (columnId) => !columnsState[columnId].canHide
      ),
    };
  }
);
